// extracted by mini-css-extract-plugin
export default {"timeInput":"TimeInput_timeInput__IfT9M","inputs":"TimeInput_inputs__u9qTA"};